import React from 'react';

interface CharacterMessageProps {
  selectedImage?: string;
  currentPortrait?: string;
  loaders?: {
    characterGenerating?: boolean;
    characterRegenerate?: boolean;
  };
  bookData?: {
    isImageProcessing?: boolean;
  };
}

const CharacterMessage: React.FC<CharacterMessageProps> = ({
                                                             selectedImage,
                                                             currentPortrait,
                                                             loaders,
                                                             bookData
                                                           }) => {
  return (
    <>
      {selectedImage || currentPortrait ? (
        <p className="my-4 md:my-6 text-left text-sm text-storyblue w-full lg:w-[70rem]">
          {loaders?.characterGenerating || loaders?.characterRegenerate || bookData?.isImageProcessing
            ? ''
            : `When you describe your character make sure to use simple descriptions.`}
        </p>
      ) : (
        <p className="my-4 text-left text-sm text-storyblue w-full lg:w-[70rem]">
          Let’s Build My Character. Please upload a headshot with no other people or objects.
        </p>
      )}
    </>
  );
};

export default CharacterMessage;
